import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: linear-gradient(#f40350, #cc00b0);

  .panel {
    padding: 40px;
    background-color: #fff;
    border-radius: 5px;
    text-align: center;
    max-width: 400px;

    h2 {
      font-size: 28px;
      margin-bottom: 30px;
    }

    .note {
      margin: 20px 0 0 0;
      color: #888;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/Auth/styles.js